// On Watchlist is guided by signinginterest.js
// Manage Contract is guided by contracts.js

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./VSNtransfers.css";

const VSNtransfers = ({ userId, role }) => {
  const [activeTab, setActiveTab] = useState("Signing Offers");
  const navigate = useNavigate();

  // Normalize role casing to lowercase
  const normalizedRole = (role || "").toLowerCase();

  // ✅ Add playerId (so new pages can use it if needed)
  const playerId = localStorage.getItem("playerId") || null;

  // Debug: log the props received by VSNtransfers
  useEffect(() => {
    console.log("🧭 VSNtransfers received:", {
      userId,
      playerId,
      role: normalizedRole,
    });
  }, [userId, playerId, normalizedRole]);

  const handleTabClick = (tabName, path) => {
    console.log("➡️ Navigating to:", path, "with:", {
      userId,
      playerId,
      role: normalizedRole,
    });

    setActiveTab(tabName);

    navigate(path, {
      state: { userId, playerId, role: normalizedRole },
    });
  };

  return (
    <div className="vsn-wrapper">
      <div className="vsn-transfers">
        <h3 className="vsn-title">VSN Transfers</h3>

        <div className="vsn-button-stack">
          <button
            className={activeTab === "Signing Offers" ? "active" : ""}
            onClick={() => handleTabClick("Signing Offers", "/signing-offer")}
          >
            Signing Offers
          </button>

          <button
            className={activeTab === "On Watchlist" ? "active" : ""}
            onClick={() => handleTabClick("On Watchlist", "/signing-interest")}
          >
            On Watchlist
          </button>

          <button
            className={activeTab === "Manage Contract" ? "active" : ""}
            onClick={() => handleTabClick("Manage Contract", "/contracts")}
          >
            Manage Contract
          </button>
        </div>
      </div>
    </div>
  );
};

export default VSNtransfers;











